import {FC} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTIcon, WithChildren} from '../../../../helpers'
import {useLayout} from '../../../core'
import {AdminBusinessFilterIndicator} from './AdminBusinessFilterIndicator'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  type?: 'link' | 'href'
  target?: string
  isDisabled?: boolean
  click?: () => void
  isDesktopOnly?: boolean
  /** Other paths that belong to this item, e.g. the tabs of the page it opens. */
  activePaths?: string[]
  /** The page follows an administrator's selected business: show the on/off business-filter mark. */
  businessFilter?: boolean
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  target,
  icon,
  fontIcon,
  hasBullet = false,
  type = 'link',
  isDisabled = false,
  click,
  isDesktopOnly = false,
  activePaths = [],
  businessFilter = false,
}) => {
  const {pathname} = useLocation()
  const isActive =
    checkIsActive(pathname, to) || activePaths.some((path) => checkIsActive(pathname, path))
  const {config} = useLayout()
  const {app} = config

  function getMenu() {
    return (
      <>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className='menu-icon'>
            {' '}
            <KTIcon iconName={icon} className='fs-2' />
          </span>
        )}
        {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
          <i className={clsx('fs-2 me-2', fontIcon, {'text-gray-800': isDisabled})}></i>
        )}
        <span className={clsx('menu-title', {'text-gray-800': isDisabled})}>{title}</span>
        {businessFilter && <AdminBusinessFilterIndicator />}
      </>
    )
  }

  return (
    <div
      className={clsx('menu-item', {'d-none d-lg-block': isDesktopOnly})}
      onClick={
        click
          ? () => {
              click()
            }
          : () => {}
      }
    >
      {isDisabled ? (
        <span className='menu-link without-sub' style={{cursor: 'not-allowed'}}>
          {getMenu()}
        </span>
      ) : (
        <>
          {type == 'link' && (
            <Link className={clsx('menu-link without-sub', {active: isActive})} to={to}>
              {getMenu()}
            </Link>
          )}
          {type == 'href' && (
            <a className='menu-link without-sub' href={to} target={target || '_blank'}>
              {getMenu()}
            </a>
          )}
        </>
      )}
      {children}
    </div>
  )
}

export {SidebarMenuItem}
